


















































import Vue from 'vue';
import InfoBox from '@/components/InfoBox.vue';
import { copyToClipboard } from '@/utils';

const subjectPrefix = 'Shared from Pleatt';

export default Vue.extend({
  props: {
    message: String,
    title: String,
    url: {
      type: String,
      default: () => location.href,
    },
  },
  data: () => ({
    copyTimeout: undefined as any,
    showCopied: false,
  }),
  computed: {
    subject() {
      return this.title
        ? `${subjectPrefix}: ${this.title}`
        : subjectPrefix;
    },
    output() {
      return this.message
        ? `${this.message}%0d%0a%0d%0a${this.url}`
        : this.url;
    },
  },
  methods: {
    copy() {
      copyToClipboard(this.url);

      // show copied message
      this.showCopied = true;
      clearTimeout(this.copyTimeout);
      this.copyTimeout = setTimeout(() => {
        this.showCopied = false;
      }, 2000);
    },
    print() {
      window.print();
    },
  },
  components: {
    InfoBox,
  },
});
